import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import { defaultsDeep } from 'lodash';
import defaultSurveyStyles from '../config/defaultSurveyStyles';
import Constants from '../../../constants/actions';

export default handleActions(
  {
    [Constants.SET_EDITOR_ACTIVE_SURVEY]: (state, { payload }) =>
      update(state, {
        $set: defaultsDeep(
          {},
          payload.defaultStylesSnapshot,
          defaultSurveyStyles,
        ),
      }),
  },
  defaultSurveyStyles,
);
